// Translations
import landing from '../views/landing/translations/tr'

// Translation: Register (Turkish)
export default Object.freeze({
	name: 'Kayıt',
	views: { landing }
})
